import type { CSSProperties } from "react";

/** Fixed 0–1 scale, so the same score has the same shade in every TE. */
export function scoreColor(score: number): CSSProperties {
  const value = Math.max(0, Math.min(1, score));
  return {
    backgroundColor: `color-mix(in srgb, var(--color-score-high) ${value * 100}%, var(--color-score-low))`,
    color: value >= 0.86 ? "var(--color-score-light-text)" : "var(--color-score-dark-text)",
  };
}

export const SCORE_GRADIENT = "linear-gradient(to right, var(--color-score-low), var(--color-score-high))";
